import type { APInvoice } from '@erp/rpc';

export interface SyncToERPButtonProps {
  invoice: APInvoice;
}

/**
 * Generic component that renders the appropriate ERP sync button based on
 * the organization's enabled integrations.
 *
 * This component follows a strategy pattern where each ERP integration
 * can provide its own sync button implementation. Only buttons for enabled
 * integrations will be rendered.
 *
 * To add a new ERP integration:
 * 1. Create a new folder under integrations/ (e.g., integrations/netsuite/)
 * 2. Create a sync button component (e.g., NetSuiteSyncButton.tsx)
 * 3. Add the integration check and rendering logic below
 */
// NOTE: param _invoice currently unused (kept via '_' prefix) — revisit and delete if not needed
export function SyncToERPButton({ invoice: _invoice }: SyncToERPButtonProps) {
  // Temporarily hidden - Famous API is not enabled
  // TODO: Re-enable when Famous voucher creation API is ready
  return null;

  // const { isModuleEnabled } = useIsModuleEnabled();
  //
  // // Check which ERP integrations are enabled
  // const isFamousEnabled = isModuleEnabled(ProductModule.FAMOUS_INTEGRATION);
  //
  // // Render nothing if no ERP integrations are enabled
  // if (!isFamousEnabled) {
  //   return null;
  // }
  //
  // // Render the appropriate sync button(s) based on enabled integrations
  // // Note: In the future, if multiple ERP integrations could be enabled simultaneously,
  // // this could render multiple buttons or provide a dropdown to select which ERP to sync to
  // return (
  //   <>
  //     {isFamousEnabled && <FamousVoucherSyncButton invoice={invoice} />}
  //     {/* Add other ERP integration buttons here as needed */}
  //   </>
  // );
}
